export enum ClientAppEnum {
  Unknown = 0,
  Snapchat = 1,
  Bitmoji = 2,
}
